<template>
  <div element-loading-text="项目加载中" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" class="project" onselectstart="return false"
    style="-moz-user-select:none;">
    <!-- :data="data"  :expand-on-click-node='false'-->
    <el-tree :load="loadNode" lazy node-key="levelId" :props="defaultProps"
      @node-click="handleNodeClick" ref='Tree' :highlight-current='true' :style="{backgroundColor:'#F0F0F0'}"
      :default-expanded-keys="defaultExpandedKeys" accordion>
      <span slot-scope="{node,data}">
        <span :style="{fontSize: '15px',display:'flex',alignItems:' center'}"><span
            :style="{fontSize: '12px',backgroundColor:'#1B13BF',color:'#ffffff',borderRadius:'100%',width:'15px',height:'15px',display:'flex',alignItems:' center',justifyContent:'center',marginRight: '10px'}">{{ data.iconText }}</span>{{ data.label }}</span>
      </span>

    </el-tree>

  </div>
</template>

<script>
  import VueEventBus from '@/model/VueEventBus'
  import {
    decryptByAes,
    roleByLoginAccount,
    getUserByLoginAccount,
    getProjectinfoByUserId,
    getProjectSectionByUserId,
    getBuildList,
    getProjectSiteListById,
    buildByUserId,
    projectSiteByUserId,
    projectInfoById,
    sectionListByProjectId,
    getUserInfoById,
    getCrbimuid

  } from '@/common/api.js'

  export default {
    data() {
      return {
        loading: false,
        nodeGrade: 1,
        userAccount: sessionStorage.getItem('userAccount'),
        data: [],
        defaultProps: {
          children: 'children',
          label: 'label',
          isLeaf: 'leaf'
        },
        user: {},
        projectSiteList: [],
        projectList: [],
        sectionList: [],
        buildList: [],
        userId: sessionStorage.getItem('userId'),
        treeClickCount: 0,
        timer: null,
        userRole: '',
        buildListCount: 0,
        projectSiteListCount: 0,
        levelId: undefined,
        defaultExpandedKeys: [],
        getTreeCount: 0,
        resolve_had:null,
        node_had:null
      }
    },



    created() {},
    mounted() {
      VueEventBus.$on('handleProjectTree', (val) => {
        let node = this.$refs.Tree.getNode(val).data
        if(node.nodeGrade!=4){
          this.defaultExpandedKeys = [val]
        }
        this.handleNodeClick(node)
      })
    },


    methods: {
      loadNode(node, resolve) {
        if(this.$store.state.userRole=='施工'||this.$store.state.userRole=='监理' ||this.$store.state.userRole=='第三方检测公司'){
          if (node.level === 0) {
            setTimeout(() => {
              // 获取懒加载项目层级下的树
              getProjectinfoByUserId({
                userId: sessionStorage.getItem('userId'),
              }).then((res) => {
                if (res.success) {
                  if (res.data.length > 0) {

                    let arr = []
                    res.data.forEach((item) => {
                      arr.push({
                        iconText: '项',
                        label: item.name,
                        id: item.id,
                        nodeGrade: 1,
                        levelId: '1' + item.id.toString(),
                        leaf:false,
                      })
                    })
                    if(this.$store.state.userRole=='施工'||this.$store.state.userRole=='监理'||this.$store.state.userRole=='第三方检测公司'){
                      this.$store.commit('setTreeNode', arr[0])
                    }else{
                      let obj = {
                          iconText: '项',
                          label:'京昆高速铁路西昆有限公司',
                          nodeGrade: 0,
                          levelId: 0,
                      }
                      this.$store.commit('setTreeNode', obj)
                    }
                    resolve(arr);
                    this.defaultExpandedKeys = [arr[0].levelId]
                  } else {
                    this.$message.warning('暂无项目')
                    return resolve([]);
                  }
                } else {
                  this.$message.error(res.message)
                  return resolve([]);
                }
              }).catch((err) => {
                console.log(err)
                return resolve([]);
              })
            },1000)

          }
          if (node.level === 1) {
            sectionListByProjectId({
              projectId: node.data.id,
              userId: sessionStorage.getItem('userId'),
            }).then((res) => {
              if (res.success) {
                if (res.data.length > 0) {

                  let arr = []
                  res.data.forEach((item) => {

                    arr.push({
                      iconText: '标',
                      label: item.name,
                      id: item.id,
                      nodeGrade: 2,
                      levelId: '2' + item.id.toString(),
                      projectId: node.data.id,
                      projectName: node.data.label,
                      leaf:false,
                    })
                  })
                  return resolve(arr);
                } else {
                  this.$message.warning('暂无标段')
                  return resolve([]);
                }
              } else {
                this.$message.error(res.message)
                return resolve([]);
              }
            }).catch((err) => {
              console.log(err)
              return resolve([]);
            })
          }
          if (node.level === 2) {
            getBuildList({
              sectionId: node.data.id,
              userId: sessionStorage.getItem('userId'),
            }).then((res) => {
              if (res.success) {

                if (res.data.length > 0) {

                  let arr = []
                  res.data.forEach((item) => {
                    arr.push({
                      iconText: '隧',
                      label: item.name,
                      id: item.id,
                      nodeGrade: 3,
                      levelId: '3' + item.id.toString(),
                      projectId: node.data.projectId,
                      projectName:node.data.projectName,
                      sectionId: node.data.id,
                      sectionName:node.data.label,
                      leaf:false,
                    })
                  })
                  return resolve(arr);
                } else {
                  this.$message.warning('暂无隧道')
                  return resolve([]);
                }
              } else {
                this.$message.error(res.message)
              }
            }).catch((err) => {
              console.log(err)
              return resolve([]);
            })
          }
          if (node.level === 3) {
            getProjectSiteListById({
              buildId: node.data.id,
              userId: sessionStorage.getItem('userId'),
            }).then((res) => {
              if (res.success) {
                if (res.data.length > 0) {
                  let arr = []
                  res.data.forEach((item) => {
                    arr.push({
                      iconText: '工',
                      label: item.name,
                      id: item.id,
                      nodeGrade: 4,
                      levelId: '4' + item.id.toString(),
                      projectId: node.data.projectId,
                      sectionId: node.data.sectionId,
                      buildId: node.data.id,
                      projectName:node.data.projectName,
                      sectionName:node.data.sectionName,
                      buildName: node.data.label,
                      leaf:true,
                    })
                  })
                  return resolve(arr);
                } else {
                  this.$message.warning('暂无工点')
                  return resolve([]);
                }
              } else {
                this.$message.error(res.message)
                return resolve([]);
              }

            }).catch((err) => {
              console.log(err)
              return resolve([]);
            })
          }
        }else if(this.$store.state.userRole == '建设'){
          if (node.level === 0) {
            let arr = []
            setTimeout(() => {
              let obj = {
                    iconText: '建',
                    label:'京昆高速铁路西昆有限公司',
                    nodeGrade: 0,
                    levelId: 0,
                }
                arr.push(obj)
                this.$store.commit('setTreeNode', obj)
              resolve(arr);
              this.defaultExpandedKeys = [arr[0].levelId]
            },1000)

          }
          if (node.level === 1) {
            setTimeout(() => {
              // 获取懒加载项目层级下的树
              getProjectinfoByUserId({
                userId: sessionStorage.getItem('userId'),
              }).then((res) => {
                if (res.success) {
                  if (res.data.length > 0) {

                    let arr = []
                    res.data.forEach((item) => {
                      arr.push({
                        iconText: '项',
                        label: item.name,
                        id: item.id,
                        nodeGrade: 1,
                        levelId: '1' + item.id.toString(),
                        leaf:false,
                      })
                    })
                    this.$store.commit('setTreeNode', arr[0])
                    resolve(arr);
                    this.defaultExpandedKeys = [arr[0].levelId]
                  } else {
                    this.$message.warning('暂无项目')
                    return resolve([]);
                  }
                } else {
                  this.$message.error(res.message)
                  return resolve([]);
                }
              }).catch((err) => {
                console.log(err)
                return resolve([]);
              })
            },1000)
          }
          if (node.level === 2) {
            sectionListByProjectId({
              projectId: node.data.id,
              userId: sessionStorage.getItem('userId'),
            }).then((res) => {
              if (res.success) {
                if (res.data.length > 0) {

                  let arr = []
                  res.data.forEach((item) => {

                    arr.push({
                      iconText: '标',
                      label: item.name,
                      id: item.id,
                      nodeGrade: 2,
                      levelId: '2' + item.id.toString(),
                      projectId: node.data.id,
                      projectName: node.data.label,
                      leaf:false,
                    })
                  })
                  return resolve(arr);
                } else {
                  this.$message.warning('暂无标段')
                  return resolve([]);
                }
              } else {
                this.$message.error(res.message)
                return resolve([]);
              }
            }).catch((err) => {
              console.log(err)
              return resolve([]);
            })
          }
          if (node.level === 3) {
              getBuildList({
                sectionId: node.data.id,
                userId: sessionStorage.getItem('userId'),
              }).then((res) => {
                if (res.success) {

                  if (res.data.length > 0) {

                    let arr = []
                    res.data.forEach((item) => {
                      arr.push({
                        iconText: '隧',
                        label: item.name,
                        id: item.id,
                        nodeGrade: 3,
                        levelId: '3' + item.id.toString(),
                        projectId: node.data.projectId,
                        projectName:node.data.projectName,
                        sectionId: node.data.id,
                        sectionName:node.data.label,
                        leaf:false,
                      })
                    })
                    return resolve(arr);
                  } else {
                    this.$message.warning('暂无隧道')
                    return resolve([]);
                  }
                } else {
                  this.$message.error(res.message)
                }
              }).catch((err) => {
                console.log(err)
                return resolve([]);
              })
          }
          if (node.level === 4) {
            getProjectSiteListById({
              buildId: node.data.id,
              userId: sessionStorage.getItem('userId'),
            }).then((res) => {
              if (res.success) {
                if (res.data.length > 0) {
                  let arr = []
                  res.data.forEach((item) => {
                    arr.push({
                      iconText: '工',
                      label: item.name,
                      id: item.id,
                      nodeGrade: 4,
                      levelId: '4' + item.id.toString(),
                      projectId: node.data.projectId,
                      sectionId: node.data.sectionId,
                      buildId: node.data.id,
                      projectName:node.data.projectName,
                      sectionName:node.data.sectionName,
                      buildName: node.data.label,
                      leaf:true,
                    })
                  })
                  return resolve(arr);
                } else {
                  this.$message.warning('暂无工点')
                  return resolve([]);
                }
              } else {
                this.$message.error(res.message)
                return resolve([]);
              }

            }).catch((err) => {
              console.log(err)
              return resolve([]);
            })
          }
        }



      },




      handleNodeClick(data) {
        console.log(data);
        if (data.nodeGrade != 0) {
          sessionStorage.setItem('nodeGrade', data.nodeGrade)

          sessionStorage.setItem('treeNode', data)
          this.$store.commit('setTreeNode', data)
        }
      },

      //请求失败时执行



    },

  };
</script>

<style>
  .project {
    background-color: #F0F0F0;
    width: 287px;
    height: auto;
    /* max-height: 100%; */
    position: fixed;
    border-right: 1px solid #696969;
    top: 70px;
    bottom: 0;
    z-index: 500 !important;
    overflow-y: auto;
    /* padding-bottom: 96px; */
    overflow-x: auto;
    padding-top: 12px;

  }

  .el-tree-node__label {
    font-size: 18px !important;
    width: auto !important;
    /* overflow: hidden !important; */
    text-overflow: ellipsis !important;
  }

  .el-tree-node>.el-tree-node__children {
    overflow: visible !important;
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/Project.vue